module.exports = __webpack_public_path__ + "static/media/tbilisi4.18fda9fa.jpg";